
import React from 'react'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuth } from '@selectors'
import { addContactsAction } from '@redux/actions/safewalk'
import { HIDE_ACTION_SHEET } from '@redux/actions/types'
import { ActionSheet } from '@omnilert/components'
import SafeWalkContactForm from '@components/safewalk-contact-form/safewalk-contact-form.component'

import useStyles from './add-contacts-form-action-sheet.style'

const AddContactsFormActionSheet = props => {
  const isVisible = useSelector((state) => state.sheet.actionSheet === 'CONTACTS')

  const classes = useStyles(props)

  const dispatch = useDispatch()

  const auth = useSelector(selectAuth)

  const { userConfig, hash, apiKey } = auth

  const contacts = userConfig?.emergency_contacts || []

  const handleOnCloseActionSheet = () => dispatch({ type: HIDE_ACTION_SHEET })

  const onSubmitContacts = ({ contacts: formContacts }) => {
    dispatch(addContactsAction({
      apiKey,
      contacts: formContacts,
      hash
    }))
  }
  return (
    <ActionSheet
      className={classes.actionSheet}
      onClose={handleOnCloseActionSheet}
      show={isVisible}
    >
      {isVisible &&
        <div className={classes.content}>
          <SafeWalkContactForm
            contacts={contacts}
            onSubmit={onSubmitContacts}
          />
        </div>}
    </ActionSheet>
  )
}

AddContactsFormActionSheet.defaultProps = {
  isVisible: false
}

AddContactsFormActionSheet.propTypes = {
  isVisible: PropTypes.bool
}

export default AddContactsFormActionSheet
